<script>

    import { onMount,beforeUpdate } from "svelte";

	export let appdesc;
	export let connections;

	$: currentReoucreURL ='';
	let currentRessourceType;
	$: sourcecode=((appdesc && appdesc.label)? 'Select a resource for '+appdesc.label : 'Select a resource');

    $: ID = (appdesc && appdesc.uri) ? appdesc.uri
        .replace(/http:/,'')
        .replace(/:/g,'')
        .replace(/\//g,'')
        .replace(/\./g,'')
        .replace(/\_/g,'') : '';

    $: language ='de';

     onMount(async function() {
         sourcecode ='';

         if (appdesc && appdesc.languages && appdesc.languages.length>1){
             language = languages[0];
         }

     });

     async function fetchSource (sourceURL, type) {
        currentReoucreURL = sourceURL;
        currentRessourceType = type;
        sourcecode= 'Loading ...';
        fetch(sourceURL)
         .then (async (response) => {
             sourcecode = await response.text();
             return true;
         })
         .catch( a => sourcecode =' error loading content: '+a)
     }

     async function openInWindow () {
         if (currentRessourceType ==='text') {
            var myWindow = window.open('', "_blank" , "toolbar=yes,scrollbars=yes,resizable=yes,top=300,left=300,width=800,height=400");
            myWindow.document.open();
            myWindow.document.write('<PLAINTEXT>'+sourcecode);
         } else {
             window.open ( currentReoucreURL, "", "toolbar=yes,scrollbars=yes,resizable=yes,top=200,left=200,width=800,height=400");
         }
    }

    function showAppResourceInWindow (appURI, resource ) {
        var appURL = connections.mimesisResources_URL
        + '?resourceURL=' +appURI+ '/' + resource;
        fetchSource ( appURL );
    }

    function showAppOntologyInWindow (appURI ) {
        var appURL = connections.mimesisAppModelOntology_URL
            + '?applicationURI=' +appURI;
        fetchSource ( appURL );
    }

    function showGeneratedAppInWindow (technology) {

        let appURI = appdesc.uri;
        let variant = 'root';

        let specs=undefined;

        if (!variant) variant = root;
        if (!technology) variant = semanticui;
        if (!language) language = 'de';

        var appURL = connections.mimesisUI_URL
            + "\?applicationURI="+appURI
            + "&variantURI="+appURI+'/variants%23'+variant
            + '&technology='+technology
            + '&language='+language;

       fetchSource ( appURL , 'text');

    }

    function showIntermediateResult (type) {

        let appURI = appdesc.uri;
        let variant = 'root';
        let endpoint = connections.mimesisUI_URL;

        if (type == 'mimesisAbstractUI'){
            endpoint = connections.mimesisAbstractUI_URL;
        } else if (type == 'mimesisCombinedUI') {
            endpoint = connections.mimesisCombinedUI_URL;
        }

        if (!language) language = 'de';
        var appURL = endpoint
            + "\?applicationURI="+appURI
            + "&variantURI="+appURI+'/variants%23'+variant
            + '&language='+language;

       fetchSource ( appURL , 'text');
    }

</script>

<style>
.btn {
    margin : .2em;
    }
.card {
    padding:1em;
    height:100%;
    overflow: auto;
}
.card h3 {
    padding:0 0 1em 0;
    margin:0em;
}

</style>


<div class=" jumbotron card" style="flex-flow: column;" >

{#if appdesc}
     <div class="row text-center">
        <h3>  {@html appdesc.label} {#if appdesc.subtitle}<br><small>{@html appdesc.subtitle}</small>{/if}</h3>
         <span style="text-align:left;">
             <div>
                 {@html appdesc.description}
             </div>

         </span>
     </div>


     {#if appdesc.uri}
        <!-- DEFAULT RESOURCES -->
        <div class="row text-center">
            <h4>Basic Applicaiton Ressources:</h4>
            <div class="row">
                <a class="btn btn-info col-4"
                   on:click={ () => showAppResourceInWindow(appdesc.uri,'')}
                   target="source" >Application Model</a>
                <a class="btn btn-info col-4"
                   on:click={ () => showAppResourceInWindow(appdesc.uri,'variants')}
                   target="source" >Variant Description</a>
                {#each appdesc.languages as lng}
                  <a class="btn btn-info col-4"
                     on:click={ () => showAppResourceInWindow(appdesc.uri,'assets/'+lng+'_app_labels.properties')}
                     target="source" >Asset - labels ({lng}) </a>
                {/each}
                <a class="btn btn-info col-4"
                    on:click={ () => showAppResourceInWindow(appdesc.uri,'uiresources/scripts.js')}
                    target="source" >Code (JavaScript)</a>
                <a class="btn btn-info col-4"
                    on:click={ () => showAppOntologyInWindow(appdesc.uri)}
                    target="source" >Ontological Application Model</a>
            </div>
        </div>

        <!-- GENERATED RESULTS  -->
        {#if appdesc.generatedresults}
            {#if appdesc.languages && appdesc.languages.length>1}
                <div class="row text-center">
                 Select language: <select bind:value={language}>
                     {#each appdesc.languages as lng}
                         <option value={lng}>
                             {lng}
                         </option>
                     {/each}
                 </select>
                </div>
            {/if}
        {/if}
        {#if appdesc.intermediateresults}
            <div class="row text-center">
                <h4>Intermediate Results:</h4>
                <div class="row">
                    {#each appdesc.intermediateresults as res}
                      <a class="btn btn-info col-4"
                         on:click={ () => showIntermediateResult(res.type)}>{res.label}
                      </a>
                    {/each}
                </div>
            </div>
        {/if}
        {#if appdesc.generatedresults}
            <div class="row text-center">
                <h4>Generated Sources:</h4>
                <div class="row">
                    {#each appdesc.generatedresults as res}
                      <a class="btn btn-info col-4"
                         on:click={ () => showGeneratedAppInWindow(res.technology)}>{res.label}
                      </a>
                    {/each}
                </div>
            </div>
        {/if}
    {/if}
    {#if appdesc.resources}
        <div class="row text-center">
            <h4>Link Ressources:</h4>
            <div class="row">
                {#each appdesc.resources as res}
                  <a class="btn btn-info col-4"
                     on:click={ () => fetchSource(res.url, res.type)}>{res.label}
                  </a>
               {/each}
             </div>
         </div>
    {/if}

    {#if appdesc.uri || appdesc.resources}
        <a class="col-2" on:click={ () => openInWindow()} > Open in separate window </a>
        <span style="flex-grow: 1;">
            <pre style="background-color:white;  overflow:auto; height: 300px; font-size:.7em;">
             {sourcecode}
            </pre>
        </span>
    {/if}

{:else}
    <div class="row text-center">
        <div>
            Please Select Application
        </div>
    </div>

{/if }

</div>
